import React, { useEffect, useRef, useState } from "react"
import "./slider.scss"
import { Swiper, SwiperSlide } from "swiper/react"
import { Navigation, A11y } from "swiper"
import { SliderProps } from "../../types/components"
import { FetchedSlideProps } from "../../types/shared-singulars"
import { ArrowLeft, ArrowRight } from "../elements/svg-elements"
import { isDocument } from "../../utils/constants"
import SliderItem from "./slider-item"

const Slider: React.FC<SliderProps> = ({ children, parent, slides }) => {
  const [margin, setMargin] = useState<number | undefined>(10)
  const containerRef = useRef<any>()

  const calculatedMargin = () => {
    if (isDocument()) {
      let container = containerRef.current
      return container?.offsetLeft
    }
  }
  const swiperOptions = {
    modules: [Navigation, A11y],
    spaceBetween: 30,
    slidesPerView: 1,
    loop: false,
    slidesOffsetBefore: margin,
    slidesOffsetAfter: margin,
    freeMode: true,
    preventClicks: true,
    preventClicksPropagation: true,
    navigation: {
      prevEl: ".slider__header__navigation__previous",
      nextEl: ".slider__header__navigation__next",
    },
    breakpoints: {
      2500: { slidesPerView: 7 },
      2100: { slidesPerView: 6.2 },
      1921: { slidesPerView: 5 },
      1100: { slidesPerView: 3.5, spaceBetween: 30 },
      850: { slidesPerView: 3.1 },
      750: { slidesPerView: 2.7 },
      560: { slidesPerView: 2.3, spaceBetween: 20 },
      481: { slidesPerView: 2 },
      380: { slidesPerView: 1.2, spaceBetween: 15 },
    },
  }
  useEffect(() => {
    setMargin(calculatedMargin())
    return () => setMargin(calculatedMargin())
  }, [calculatedMargin()])

  function classGenerator() {
    switch (parent) {
      case "team-slider":
        return "slider team"
      case "article-slider":
        return "slider articles"
      default:
        return
    }
  }

  return (
    <div className={classGenerator()}>
      <div
        id="container"
        ref={containerRef}
        className="slider__header container--xl"
        data-aos="fade-up"
        data-aos-delay="100"
        data-aos-easing="ease-out"
      >
        {children}
        <div className="slider__header__navigation">
          <ArrowLeft className="slider__header__navigation__previous" />
          <ArrowRight className="slider__header__navigation__next" />
        </div>
      </div>
      <Swiper {...swiperOptions}>
        {slides &&
          slides?.map((slide: FetchedSlideProps, index: number) => (
            <SwiperSlide key={index}>
              <SliderItem
                parent={parent}
                uri={slide?.uri}
                imgProps={slide?.featuredImage?.node}
                authors={slide?.singleArticleOptions?.authorSelector}
                title={slide?.title}
                memberTag={slide?.singleTeam?.position}
              />
            </SwiperSlide>
          ))}
      </Swiper>
    </div>
  )
}

export default Slider
